<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'almacen' }">{{
                $t("almacen")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("historialDeAlmacen") }}
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-6" v-if="sectores && $cookies.isKey('sectores')">
              <div class="form-group">
                <label for="listSectores">{{ "Sector" }}</label>
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idSector"
                  filterable
                  :placeholder="'Selecciona un sector'"
                  @change="cambioSector()"
                >
                  <el-option
                    v-for="(sector, index) in listaSectores"
                    class="select-primary"
                    :value="sector.id"
                    :label="sector.name"
                    :key="index"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-md-6" v-if="this.idSector != 0 && this.sectores">
              <div class="form-group">
                <label for="listBusiness">{{ $t("negocio") }}</label>
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  :placeholder="this.$i18n.t('seleccionaNegocio')"
                  @change="cambioBusiness()"
                > 
                  <el-option
                  class="select-primary"
                  :value="-1"
                  :label="'Todos'"
                >
                </el-option>
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-md-6" v-else-if="this.sectores">
              <div class="form-group">
                <label for="listBusiness">{{ $t("negocio") }}</label>
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  :placeholder="this.$i18n.t('seleccionaNegocio')"
                  @change="cambioBusiness()"
                > 
                  <el-option
                    v-for="business in listaNegociosSinSector"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.establishmentName"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-md-6" v-else>
              <div class="form-group">
                <label for="listBusiness">{{ $t("negocio") }}</label>
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  :placeholder="this.$i18n.t('seleccionaNegocio')"
                  @change="cambioBusiness()"
                > 
                  <el-option
                  class="select-primary"
                  :value="-1"
                  :label="'Todos'"
                >
                </el-option>
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>{{ $t("fechaInicio") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  format="dd-MM-yyyy"
                  :title="$t('fechaInicio')"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  v-model="datefrom"
                ></datetime>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{ $t("fechaFin") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  :title="this.$i18n.t('fechaFin')"
                  format="dd-MM-yyyy"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  v-model="dateto"
                ></datetime>
              </div>
            </div>

            <div class="col-md-2">
              <label>&nbsp;</label>
              <div class="form-group">
                <button class="btn btn-primary" @click="getInventario()">
                  <i class="fa fa-refresh" v-if="loading"></i>
                  {{ $t("consultar") }}
                </button>
              </div>
            </div>

            <div class="col-md-12">
              <label
                ><strong>{{ $t("tipo") }}</strong></label
              >
              <div class="form-group">
                <el-radio @change="getInventario()" v-model="tipo" :label="0">{{
                  $t("todos")
                }}</el-radio>
                <el-radio @change="getInventario()" v-model="tipo" :label="1"
                  >{{ $t("inventarios") }}
                </el-radio>
                <el-radio @change="getInventario()" v-model="tipo" :label="2"
                  >{{ $t("entradas") }}
                </el-radio>
                <el-radio @change="getInventario()" v-model="tipo" :label="3"
                  >{{ $t("salidas") }}
                </el-radio>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="card">
          <template v-if="(listAlmacen.length > 0) | diaActual">
            <div class="row">
              <div class="col-md-12 table-responsive" style="overflow: auto">
                <table class="table table-bordered table-striped ">
                  <thead class="thead-dark">
                    <tr>
                      <th>{{ $t("fecha") }}</th>
                      <th v-if="sectores && idSector != 0">{{ $t('nombre') + " del TPV" }}</th>
                      <th>{{ $t("concepto") }}</th>
                      <th width="13%">{{ $t("completado") }}</th>
                      <th width="13%">{{ $t("verificado") }}</th>
                      <th width="13%">{{ $t("descargado") }}</th>
                      <th>{{ $t("acciones") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-if="tipo === 0"
                      class="table-success"
                      v-for="d in diaActual"
                    >
                      <td>
                        <div>
                          <strong>{{ d.initDate | parseDate }}</strong>
                        </div>
                      </td>
                      <td :colspan="(sectores && idSector != 0) || !sectores ? '4' : '5'" align="center">
                        <strong>**{{ $t("diaActual") }}**</strong>
                      </td>
                      <td align="center">
                        <router-link
                          v-if="sectores && idSector != 0"
                          :to="{
                            name: 'detalle-almacen',
                            params: { idAlmacen: 0, idBusiness: alm.idBusiness, nombreTpv: alm.nombreTpv },
                          }"
                        >
                          <i
                            v-tooltip.top-center="$i18n.t('verDetalles')"
                            class="fa fa-eye"
                            style="color: dodgerblue;cursor: pointer"
                          ></i>
                        </router-link>
                        <router-link
                          v-else
                          :to="{
                            name: 'detalle-almacen',
                            params: { idAlmacen: 0, idBusiness: idBusiness },
                          }"
                        >
                          <i
                            v-tooltip.top-center="$i18n.t('verDetalles')"
                            class="fa fa-eye"
                            style="color: dodgerblue;cursor: pointer"
                          ></i>
                        </router-link>
                      </td>
                    </tr>
                    <tr v-for="alm in listAlmacen">
                      <td>
                        <div>{{ alm.date | parseDate }}</div>
                      </td>
                      <td v-if="sectores && idSector != 0">
                        <div>{{ alm.nombreTpv }}</div>
                      </td>
                      <td>
                        <div>
                          {{ alm.reference }}
                          <template v-if="alm.tipo === 'I'">{{
                            $t("inventario")
                          }}</template>
                        </div>
                      </td>
                      <td>
                        <div class="text-success" v-if="alm.complete">
                          <i class="fas fa-check"></i>
                          {{ $t("si") }}
                        </div>
                        <div v-else class="text-danger">
                          <i class="fas fa-minus-circle"></i> {{ $t("no") }}
                        </div>
                      </td>
                      <td>
                        <div class="text-success" v-if="alm.verificado || alm.tipo == 'I'">
                          <i class="fas fa-check"></i>
                          {{ $t("si") }}
                        </div>
                        <div v-else class="text-danger">
                          <!--<i class="fas fa-minus-circle"></i> {{ $t("no") }}-->
                          <button @click="verificarMovimiento(alm.id)" type="button" class="ml-3 btn btn-success"><i class="fas fa-check mr-1"></i> Verificar</button>
                        </div>
                      </td>
                      <td>
                        <div class="text-success" v-if="alm.download">
                          <i class="fas fa-check"></i>
                          {{ $t("si") }}
                        </div>
                        <div v-else class="text-danger">
                          <i class="fas fa-minus-circle"></i> {{ $t("no") }}
                        </div>
                      </td>
                      <td align="center">
                        <div v-if="sectores && idSector != 0">
                          <router-link
                            :to="{
                              name: 'detalle-almacen',
                              params: {
                                nombreTpv: alm.nombreTpv,
                                idBusiness: alm.idBusiness,
                                idAlmacen: alm.id,
                              },
                            }"
                          >
                            <i
                              v-tooltip.top-center="$i18n.t('verDetalles')"
                              class="fa fa-eye"
                              style="color: dodgerblue;cursor: pointer"
                            ></i>
                          </router-link>
                        </div>
                        <div v-else>
                          <router-link

                            :to="{
                              name: 'detalle-almacen',
                              params: {
                                idBusiness: idBusiness,
                                idAlmacen: alm.id,
                              },
                            }"
                          >
                            <i
                              v-tooltip.top-center="$i18n.t('verDetalles')"
                              class="fa fa-eye"
                              style="color: dodgerblue;cursor: pointer"
                            ></i>
                          </router-link>
                          <router-link  v-if="!alm.verificado && alm.tipo !== 'I'"
                                        :to="{ name: 'editar-entrada-almacen', params: { 'idBusiness': alm.idBusiness, 'idMovimiento': alm.id } }"
                            >
                              <a class="btn btn-danger btn-link btn-xs">
                                  <i v-tooltip.top-center="$i18n.t('editar')"
                                      class="fas fa-pencil-alt" style="color: orange"></i>
                              </a>
                          </router-link>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr></tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="alert alert-danger" role="alert">
              {{ $t("noHay") }}
              <span v-if="tipo === 1">{{ $t("inventarios") }}</span
              ><span v-else-if="tipo === 2">{{ $t("entradas") }}</span
              ><span v-else-if="tipo === 3">{{ $t("salidas") }}</span
              ><span v-else>{{ $t("movimientos") }}</span>
              {{ $t("enEsteRangoDeFechas") }}.
            </div>
          </template>
        </div>
      </div>
    </div>

    <modal
      name="inventario-existente"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="true"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">
            {{ $t("tienesUnInventarioSinTerminarElDia") }}
            {{ ultimoInventario.fechaInventario | parseDate }}
          </h4>
        </div>
        <div class="modal-body">
          <p>
            {{ $t("pulseElBotonRealizarInventarioPara") }}
            <strong>{{ $t("volverARealizarlo") }}</strong
            >.
          </p>
          <p>
            {{ $t("siDeseas") }}
            <strong>{{ $t("comenzarElInventarioDeNuevo") }}</strong
            >{{ $t("comaMarqueLaCasillaEliminarDatosDeInventarioActual") }}
          </p>
        </div>
        <div class="modal-footer">
          <input
            id="eliminar-datos"
            v-model="ultimoInventario.realizarInventario"
            type="checkbox"
          /><strong
            ><label for="eliminar-datos">{{
              $t("eliminarDatosDelInventarioActual")
            }}</label></strong
          >
          <button @click="generarNuevoInventario()" class="btn btn-success">
            <i class="fas fa-box-open"></i>
            {{ $t("realizarInventario") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Radio,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import { mapState, mapMutations } from 'vuex';

export default {
  created() {
    this.$store.dispatch("setNameRoute", this.$i18n.t("historialDeAlmacen"));

    if (!this.sectores && !this.$cookies.isKey("sectores")) {
        this.getBusiness();
    } else {
        
      if (this.listaSectores.length > 1) {
        this.idSector = this.listaSectores[0].id;
        this.getBusinessesBySector();
      } else {  
        this.getSectores();
      }
    }

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Radio.name]: Radio,
  },
  data() {
    return {
      loading: false,

      //FECHA
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),

      //NEGOCIOS
      listBusinesses: [],
      listaNegociosSinSector: [],
      idBusiness: 0,

      //FECHA
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],

      //OBJ
      listAlmacen: [""],
      diaActual: [],

      tipo: 0,
      ultimoInventario: {
        hash: "",
        fechaInventario: "",
        realizarInventario: false,
      },
      businesses: [],
      idSector: 0
    };
  },
  computed: {
    ...mapState(["listaSectores", "sectores"]),
    urlExportPDF() {
      // return "../api/public/index.php/sales/exportCierreCaja/PDF?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&tipo=" + this.tipo + "&jwt=" + this.$store.getters.jwt
      return (
        "../api/public/index.php/almacen/exportHistorialAlmacen/PDF?idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom).unix() +
        "&dateto=" +
        moment(this.dateto).unix() +
        "&tipo=" +
        this.tipo +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcel() {
      // return "../api/public/index.php/sales/exportCierreCaja/Excel?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&tipo=" + this.tipo + "&jwt=" + this.$store.getters.jwt
      return (
        "../api/public/index.php/almacen/exportHistorialAlmacen/Excel?idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom).unix() +
        "&dateto=" +
        moment(this.dateto).unix() +
        "&tipo=" +
        this.tipo +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
  },
  methods: {
    ...mapMutations(['changeListaSectores']),
    getBusinessesBySector() {
      let config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      var params = {
        idBusiness: this.listaSectores[0].idBusinessMaster,
        idSector: this.idSector,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      this.axios.post(this.$store.getters.apiUrl + "general/getBusinessesBySector", params, config)
        .then(function (response) {

          if (response.data.response) {
            //Recojo todos los negocios de la carga inicial del sector seleccionado

            vm.listBusinesses = response.data.result;

            response.data.result.forEach(sector => {
              vm.businesses.push(sector.id);
            })

            vm.idBusiness = -1;

            vm.getInventario();
          }

      }).catch(function (error) {
        console.log(error);
      })
    },
    verificarMovimiento(id) {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        var params = {
          idMovimiento: id,
          idBusiness: this.idBusiness
        };

        let vm = this;
        let controller = "verifyMovimiento";
        this.axios
          .post(
            this.$store.getters.apiUrl + "almacen/" + controller,
            params,
            config
          )
          .then(function(response) {
            if (response.data.response) {

              vm.$notify({
                message: 'Movimiento'+ ' ' + "verificado" + ' ' + vm.$t('correctamente'),
                icon: 'nc-icon nc-check-2',
                timeout: 2000,
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'success'
              });

              vm.getInventario();

            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
    },
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.getInventario();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getSectores() {
      let config = {
          params: {
              jwt: this.$store.getters.jwt,
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesSectors", config)
        .then(function (response) {

            if (response.data.response) {
                response.data.result["sectores"].forEach((sector) => {
                    sector.idBusinessMaster = parseInt(sector.idBusinessMaster);
                    sector.id = parseInt(sector.id);
                });
                
                vm.changeListaSectores(response.data.result["sectores"]);

                vm.idSector = vm.listaSectores[0].id;
                //vm.idBusiness = vm.listaSectores[0].idBusinessMaster;

                //vm.loadingGeneral.close();

                //Métodos locales
                vm.getBusinessesBySector();
                //vm.getInventario();
            }
        }).catch(function (error) {
            console.log(error);
        })
    },
    generarNuevoInventario() {
      if (this.ultimoInventario.realizarInventario) {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        var params = {
          inventario: this.ultimoInventario,
        };

        let vm = this;
        let controller = "deleteInventario";
        this.axios
          .post(
            this.$store.getters.apiUrl + "almacen/" + controller,
            params,
            config
          )
          .then(function(response) {
            if (response.data.response) {
              vm.$router.push({
                name: "control-inventario",
                params: { idBusiness: vm.idBusiness },
              });
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        this.$router.push({
          name: "inventario",
          params: { query: this.ultimoInventario.hash },
        });
      }
    },
    cambioSector() {
      this.listaNegociosSinSector = [];
      this.businesses = [];

      const sector = this.listaSectores.find(sector => sector.id == this.idSector);

      if (this.idSector == 0) {
        this.idBusiness = sector.negocios[0].id;
        this.listaNegociosSinSector = sector.negocios;

        this.getInventario();

      } else {
        this.getBusinessesBySector();
      }
    },
    cambioBusiness() {
      this.getInventario();
    },
    getInventario() {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$i18n.t("ups"),
          text: this.$i18n.t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$i18n.t("ups"),
            text: this.$i18n.t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.loading = true;

          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          let idBusiness = this.idBusiness;
          let businesses = this.businesses;

          if ((!this.sectores && !this.$cookies.isKey("sectores")) || this.idSector == 0) {
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            businesses = [this.idBusiness];
          } else {

            if (this.idBusiness == -1) {
              idBusiness = this.listaSectores.find((sector) => sector.id == this.idSector).idBusinessMaster;
            } else {
              businesses = [this.idBusiness];
            }
          }
          var config = {
            params: {//this.listBusinesses : [this.idBusiness]
              idBusiness: idBusiness,
              businesses: businesses,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              tipo: this.tipo,
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          
          this.axios
            .get(this.$store.getters.apiUrl + "almacen/getInventarios", config)
            .then(function(response) {
              if (response.data.response) {
                vm.listAlmacen = response.data.result.inventario;
                vm.diaActual = response.data.result.diaActual;
              } else {
                swal({
                  title: vm.$t("accesoDenegado"),
                  text: response.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              }
              vm.loading = false;
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Almacen/HistoricoAlmacen.vue